// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"188":"5ff4bfcd","594":"6f8a045c","864":"22f38585","869":"b5823423"}[chunkId] + ".js";
};